import Settings from "../../../../../../settings/Settings";

const FONT = {
    FAMILY: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 32,
    TINT: 0x000000,
};

const TYPE_SPEED = 25; // msec per char

export default class Label extends Phaser.GameObjects.Container {
    private textToShow: string = '';
    private textFull: string;
    private label!: Phaser.GameObjects.BitmapText;
    private timerType: Phaser.Time.TimerEvent | null = null;
    private isTyping: boolean = false;

    constructor(scene: Phaser.Scene, x: number, y: number, width: number, text: string) {
        super(scene, x, y);

        this.textFull = text;

        this.setupLabel(width, text);
    }

    private setupLabel(width: number, text: string): void {
        this.label = this.scene.add.bitmapText(0, 0, FONT.FAMILY, text, FONT.SIZE);
        this.label.setTint(FONT.TINT);
        this.label.setMaxWidth(width);
        this.label.setOrigin(0.5);
        this.add(this.label);

        this.label.setAlpha(0);
    }

    private startTimer(): void {
        this.timerType?.remove();

        this.timerType = this.scene.time.addEvent({
            delay: TYPE_SPEED,
            callback: this.onTimerTick,
            callbackScope: this,
        });
    }

    public getTextBounds(): Phaser.Types.GameObjects.BitmapText.LocalBitmapTextSize {
        return this.label.getTextBounds().local;
    }

    public startTyping(): void {
        if (this.isTyping) return;

        this.isTyping = true;

        this.label.x = -this.getTextBounds().width / 2;
        this.label.y = -this.getTextBounds().height / 2;
        this.label.setOrigin(0);
        this.label.setText('');
        this.label.setAlpha(1);

        this.startTimer();
    }

    private onTimerTick(): void {
        let index = this.textToShow.length + 1;
        this.textToShow = this.textFull.slice(0, index);

        this.label.setText(this.textToShow);

        if (this.textToShow === this.textFull) {
            this.emit('done');
        } else {
            this.startTimer();
        }
    }

    public stopTyping(): void {
        if (!this.isTyping) return;
        this.isTyping = false;

        this.timerType?.remove();
        this.label?.setText(this.textFull);

        this.emit('done');
    }

    public dispose(): void {
        this.timerType?.remove();
    }
}
